import React, {  useRef, useState } from "react";
import {
  IonPage,
  IonContent,
  useIonRouter,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from "@ionic/react";
import HeaderComponent from "../../../components/HeaderComponent";
import { chatDialogs, ChatPreview } from "../../../entities/chat";
import { ChatOrderCard } from "../../../components/ChatOrderCard";
import { ChatSkeleton } from "../../../components/ChatSkeleton";
import { useLocation } from "react-router-dom";

const formatTime = (iso: string) =>
  new Date(iso).toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });

const makeId = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;

const Chat: React.FC = () => {
  const router = useIonRouter();
  const location = useLocation()
  const [chats, setChats] = useState<ChatPreview[]>();
  const [isLoading, setLoading] = useState(true);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const getDialogs = async (load:any) => {
    try {
      setLoading(load);
      const res = await chatDialogs();
      setChats(res);
    } catch (error) {
      console.log("chat");
      setChats([]);
    } finally {
      setLoading(false);
    }
  };
  
  useIonViewWillEnter(() => {
    getDialogs(true);
    setTimeout(()=>{
      console.log(location.pathname)

      if(location.pathname=='/tabs/chat'){
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        intervalRef.current = setInterval(()=>{
          // setLoading(false);
          getDialogs(false)
        },10000)      
      }
    },10000)
  }, [chats?.length]);
  useIonViewWillLeave(()=>{
    console.log("LEAVE")
    if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = null;
  },[intervalRef])


  return (
    <IonPage>
      <HeaderComponent />
      <IonContent className="bg-slate-100">
        {chats && chats.length == 0 && !isLoading ? <div className="flex items-center justify-center h-full"><p className="text-[16px] text-[#6B7280]">Нет чатов</p></div> : isLoading ? <ChatSkeleton count={10}/> :
        isLoading? <ChatSkeleton count={10}/> :
        <div className="mx-auto flex h-full max-w-md flex-col px-3 pt-3 pb-24">
         
          {chats?.map((chat) => (
            <ChatOrderCard
              key={chat.orderId}
              data={chat}
              onClick={() => router.push(`/order-chat/${chat.orderId}`)}
            />
          ))}
        </div>
        }
      </IonContent>
    </IonPage>
  );
};

export default Chat;
